import type { ButtonHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

interface ChipToggleProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected: boolean;
}

/** Chip pill de multi-seleção (sacramentos, dias da semana). */
export function ChipToggle({ selected, className, type = 'button', ...props }: ChipToggleProps) {
  return (
    <button
      type={type}
      aria-pressed={selected}
      className={cn(
        'cursor-pointer rounded-full border px-3.5 py-2 text-[12.5px] font-semibold transition-colors',
        selected
          ? 'border-transparent bg-primary text-white'
          : 'border-input bg-surface text-fg-soft hover:bg-chip',
        className,
      )}
      {...props}
    />
  );
}
